import { useState, useEffect } from 'react';
import axios from 'axios';
import { getBaseUrl } from '../../utils/getUrl';

const useHttp = (config = {}) => {
  const api = getBaseUrl();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSucces] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (config === '') {
      return;
    }
    setIsLoading(true);
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.token}`;
    axios({
      method: config.method ? config.method : 'GET',
      url: api + config.url,
      data: config.data ? config.data : {},
    })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => setIsLoading(false));
  }, [config]);

  // f-ja koja vraca error state na null
  const clearError = () => setError(null);

  // f-ja koja se koristi za sve api pozive, razdvojeni su po statusima
  const sendRequest = (conf) => {
    setIsLoading(true);
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.token}`;
    axios({
      method: conf.method ? conf.method : 'GET',
      url: api + conf.url,
      data: conf.data ? conf.data : {},
    })
      .then((response) => {
        let newData = response.data;
        if (response.status === 210) {
          setError(newData);
          return;
        }
        if (conf.status === 1) {
          // novi unos
          newData = [response.data, ...data];
          setTimeout(() => {
            setIsSucces(true);
          }, 300);
          setTimeout(() => {
            setIsSucces(false);
          }, 2400);
        } else if (conf.status === 2) {
          // izmena
          newData = data.map((item) => {
            if (item.id) {
              if (item.id === response.data.id) {
                return response.data;
              }
            } else if (item.Id) {
              if (item.Id === response.data.Id) {
                return response.data;
              }
            }
            return item;
          });
          setTimeout(() => {
            setIsSucces(true);
          }, 300);
          setTimeout(() => {
            setIsSucces(false);
          }, 2400);
        } else if (conf.status === 3) {
          newData = data.filter((item) =>
            item.id
              ? item.id !== response.data
              : item.Id
              ? item.Id !== response.data
              : null,
          );
        }
        setData(newData);
      })
      .catch((error) => {
        // console.log(error.response); // ostavljen clg kako bi i na produkciji odmah u inspect element mogli da vidimo sta je greska
        setError(error.response.data);
        if (error.message.indexOf('404') > -1) {
          setError('Neuspešan zahtev.');
        } else if (
          error.message.indexOf('500') > -1 ||
          error.message.indexOf('400') > -1
        ) {
          if (conf.status === 1) {
            if (error.response.data.includes('Cannot insert duplicate key')) {
              setError('Greška prilikom unosa podataka, zapis već postoji.');
            } else {
              setError('Greška prilikom unosa podataka.');
            }
          }
          if (conf.status === 2) {
            setError('Greška prilikom izmene podataka.');
          }
          if (conf.status === 3) {
            setError(
              error.response.data || 'Greška prilikom brisanja podataka.',
            );
          }
        } else if (error.message === 'Network Error') {
          setError('Greška na mreži.');
        } else {
          setError(error.message);
        }
        setTimeout(() => {
          setError(null);
        }, 3000);
      })
      .finally(() => {
        setIsLoading(false);
        setIsSucces(false);
      });
  };

  // f-ja koja vraca rezultat nakon api poziva, pozivati je u async funkciji
  const getData = (conf) => {
    setIsLoading(true);
    const _config = {
      method: conf.method ? conf.method : 'GET',
      url: api + conf.url,
      data: conf.data ? conf.data : {},
      onUploadProgress: conf.onUploadProgress
        ? conf.onUploadProgress
        : () => {},
    };
    const result = axios(_config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // console.log(error);
        setError(error.response.data);
        if (error.message.indexOf('404') > -1) {
          setError('Neuspešan zahtev.');
        } else if (
          error.message.indexOf('500') > -1 ||
          error.message.indexOf('400') > -1
        ) {
          if (conf.status === 1) {
            if (error.response.data.includes('Cannot insert duplicate key')) {
              setError('Greška prilikom unosa podataka, zapis već postoji.');
            } else {
              setError('Greška prilikom unosa podataka.');
            }
          }
          if (conf.status === 2) {
            setError('Greška prilikom izmene podataka.');
          }
          if (conf.status === 3) {
            setError(
              error.response.data || 'Greška prilikom brisanja podataka.',
            );
          }
        } else if (error.message === 'Network Error') {
          setError('Greška na mreži.');
        } else {
          setError(error.message);
        }
        setTimeout(() => {
          setError();
        }, 3000);
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
    return result;
  };

  const onSetData = (data) => setData(data);

  return {
    data,
    error,
    isLoading,
    sendRequest,
    isSuccess,
    clearError,
    onSetData,
    getData,
  };
};

export default useHttp;
